import { Capacitor } from "@capacitor/core";
import { StatusBar as StatusBarPlugin, Style } from "@capacitor/status-bar";
import CoreColors from "@core/styles/core.variables.json";
import { isIOS } from "./platforms.constant";

/**
 * Wrapper around Capacitor plugin statusbar
 * https://capacitor.ionicframework.com/docs/apis/status-bar
 */
export class StatusBar {
  /**
   * Returns the Capacitor plugin instance
   * @readonly
   * @static
   */
  static get plugin() {
    return StatusBarPlugin;
  }

  /**
   * Set the background color to be primary with according contrasted text color
   * @static
   */
  static setPrimaryBackground() {
    if (StatusBar.checkAvailability()) {
      StatusBar.setBackgroundColor({ color: CoreColors.primary });
      StatusBar.setStyleDark();
    }
  }

  /**
   * Set the background color to be secondary with according contrasted text color
   * @static
   */
  static setSecondaryBackground() {
    if (StatusBar.checkAvailability()) {
      StatusBar.setBackgroundColor({ color: CoreColors.secondary });
      StatusBar.setStyleDark();
    }
  }

  /**
   * Set the background color to be white with black text color
   * @static
   */
  static setWhiteBackground() {
    if (StatusBar.checkAvailability()) {
      StatusBar.setBackgroundColor({ color: "#FFFFFF" });
      StatusBar.setStyleLight();
    }
  }

  /**
   * Set the background color to be black with white text color
   * @static
   */
  static setBlackBackground() {
    if (StatusBar.checkAvailability()) {
      StatusBar.setBackgroundColor({ color: "#000000" });
      StatusBar.setStyleDark();
    }
  }

  /**
   * Set the default status bar background color
   * @static
   */
  static setDefault() {
    if (StatusBar.checkAvailability()) {
      StatusBar.setWhiteBackground();
    }
  }

  /**
   * Will show statusbar on compatible devices
   * @static
   */
  static show() {
    if (StatusBar.checkAvailability()) {
      StatusBar.plugin.show();
    }
  }

  /**
   * Will hide statusbar on compatible devices
   * @static
   */
  static hide() {
    if (StatusBar.checkAvailability()) {
      StatusBar.plugin.hide();
    }
  }

  /**
   * Set statusbar font color to be black
   * @static
   */
  static setStyleLight() {
    if (StatusBar.checkAvailability()) {
      StatusBar.plugin.setStyle({ style: Style.Light });
    }
  }

  /**
   * Set statusbar font color to be white
   * @static
   */
  static setStyleDark() {
    if (StatusBar.checkAvailability()) {
      StatusBar.plugin.setStyle({ style: Style.Dark });
    }
  }

  static checkAvailability() {
    return Capacitor.isPluginAvailable("StatusBar");
  }

  static setBackgroundColor({ color }) {
    if (isIOS) {
      // StatusBar.plugin.setBackgroundColor is not implemented on IOS
      // https://github.com/ionic-team/capacitor-site/pull/74
      return;
    }
    StatusBar.plugin.setBackgroundColor({ color });
  }
}
